import { apiFetch } from "./apiFetch";

function getLocalDateString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function completeCommitment(commitmentId) {
  return apiFetch("/completions/", {
    method: "POST",
    body: JSON.stringify({
      commitment: commitmentId,
    }),
  });
}

export function createCompletion(commitmentId, options = {}) {
  const today = getLocalDateString();

  return apiFetch("/completions/", {
    method: "POST",
    body: JSON.stringify({
      commitment: commitmentId,
      date: today,
      ...options,
    }),
  });
}

export function fetchTodaysCompletions() {
  const today = getLocalDateString();

  return apiFetch(`/completions/?date=${today}`);
}

export function undoCompletion(commitmentId) {
  const today = getLocalDateString();

  return apiFetch(
    `/completions/undo/?commitment=${commitmentId}&date=${today}`,
    { method: "DELETE" }
  );
}
